import React from 'react';

import './preloaderStyles.scss';
import { createPreloaderClassName } from './preloaderStyles';

type Props = {
  testId?: string;
};

export const PreloaderComponent: React.FC<Props> = (props) => {
  const { testId } = props;

  return (
    <div className={createPreloaderClassName('wrapper')} data-testid={testId}>
      <div
        className={`${createPreloaderClassName('spinner')} infinite-rotation`}
      />
    </div>
  );
};
